import { api, buildQueryString } from '../core';

interface chronologyGetDownloadResponse {
  downloadPath: string | null;
  downloadToken: string | null;
}

type chronologyGetDownloadProps = {
  caseId: string;
  return_full_bundle_page_numbers?: boolean;
  /** Custom CHRONOLOGY template to apply. Omit for the default template. */
  template_id?: string;
};

const chronologyGetDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChronologyGetDownload: builder.query<chronologyGetDownloadResponse, chronologyGetDownloadProps>({
      query: (params: chronologyGetDownloadProps) => {
        const queryString = buildQueryString(params);

        return {
          url: `chronology/get-download?${queryString}`,
          method: 'GET',
        };
      },
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Get was aborted');
          } else {
            console.error('Error in getChronologyGetDownload in onQueryStarted:', error);
          }
        }
      },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetChronologyGetDownloadQuery } = chronologyGetDownloadApi;
